<script setup lang="ts">
import { toRefs, computed } from 'vue';
import type { DataTableCellProps } from '@common';
import type { DecisionSupportItem } from '../models';
import { useCropStore } from '@shared';
import { storeToRefs } from 'pinia';

const props = defineProps<DataTableCellProps<any, DecisionSupportItem>>();
const { item } = toRefs(props);
const { crops } = storeToRefs(useCropStore());

const cropName = computed(() => {
  const matchingCrop = crops.value.find((crop) => crop.code === item.value.data.crop);
  return matchingCrop ? matchingCrop.name : item.value.data.crop;
});
</script>

<template>
  <div>{{ cropName }}</div>
</template>
